
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import { Typography, Box } from "@mui/material"; // Import Box for the wrapper

const baseStyle = { lineHeight: 1.4, whiteSpace: "pre-line" };

const MarkdownMessage = ({ text }) => {
  return (
    <Box sx={{ ...baseStyle, '& > *': baseStyle }}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]} // Converts single \n to <br>
        components={{
          // Use a div or Box as the container for the Typography to ensure block behavior
          p: ({ children }) => (
            // Ensure bottom margin is consistent for paragraphs
            <Typography component="div" sx={{ ...baseStyle, mb: 1.5 }}>
              {children}
            </Typography>
          ),
          strong: ({ children }) => (
            <Typography component="span" sx={{ ...baseStyle, fontWeight: "bold" }}>
              {children}
            </Typography>
          ),
          em: ({ children }) => (
            <Typography component="span" sx={{ ...baseStyle, fontStyle: "italic" }}>
              {children}
            </Typography>
          ),
          li: ({ children }) => (
            <li style={{ marginBlockEnd: '0.25em' }}>
              <Typography component="span" sx={baseStyle}>
                {children}
              </Typography>
            </li>
          ),
          h1: ({ children }) => (
            <Typography variant="h6" sx={{ ...baseStyle, fontWeight: 700, mb: 1.5 }}>
              {children}
            </Typography>
          ),
          h2: ({ children }) => (
            <Typography variant="subtitle1" sx={{ ...baseStyle, fontWeight: 700, mb: 1.5 }}>
              {children}
            </Typography>
          ),
          // Add support for line breaks generated by remarkBreaks
          br: () => <br />,
        }}
      >
        {text}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownMessage;